<template>
	<div class="footer-main">
		<footer class="footer">
			<div class="wrapper">
                <div class="footer_text">
                    © {{ year() }},  <span v-html="$t('«O!»™, ООО «НУР Телеком». Все права защищены<br>Лицензии ГАС при ГКИТиС КР:<br>ООО «НУР Телеком»: №16-0062-КР от 06.12.2016, №16-0063-КР от 06.12.2016, №14-1124-КР от 03.12.2014<br><br>Предоставление всех услуг связи регламентируется договором о предоставлении услуг связи ООО «НУР Телеком».<br><br>Услуга «Игротека» предоставляется совместно с ОсОО «Гамма Технолоджи. Лицензия №17-0192-КР от 4.08.2017<br><br>')"></span>
                    
                    <a href="/info" class="footer_link">Правила сервиса</a>
                </div>
			</div>
		</footer>
	</div>
</template>

<script>
	import moment from 'moment';

	export default {
		methods: {
			year() {
				return moment().format('Y')
			}
		},
	}
</script>
